import { combineReducers } from 'redux'
import theme from 'store/theme/themeSlice'
import auth from 'store/auth'
import base from 'store/base'
import locale from 'store/locale/localeSlice'
import config from 'store/config/configSlice'
import services from 'store/services/servicesSlice'

const createRootReducer = (asyncReducers = {}) =>
    combineReducers({
        theme,
        auth,
        base,
        locale,
        config,
        services,
        ...asyncReducers,
    })

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = createRootReducer(asyncReducers)
    return combinedReducer(state, action)
}

export { createRootReducer }

export default rootReducer
